import React, { Component } from "react";
import MultiSearchSelect from "react-search-multi-select";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      values: [
        "Allison",
        "Arthur",
        "Ana",
        "Alex",
        "Arlene",
        "Alberto",
        "Barry",
        "Bertha",
        "Bill",
        "Bonnie",
        "Bret",
        "Beryl",
        "Chantal",
        "Cristobal",
        "Claudette",
        "Charley",
        "Cindy",
        "Chris",
        "Dean",
        "Dolly",
        "Danny",
        "Danielle",
        "Dennis",
        "Debby",
        "Erin",
        "Edouard",
        "Erika",
        "Earl",
        "Emily",
        "Ernesto",
        "Felix",
        "Fay",
        "Fabian",
        "Frances",
        "Franklin",
        "Florence",
        "Gabielle",
        "Gustav",
        "Grace",
        "Gaston",
        "Gert",
        "Gordon"
      ]
    };
  }
  handleChange = (arr) => {
    console.log(arr);
  }
  render() {
    return (
      <div style={{display: 'flex', justifyContent: 'center'}}>
        <MultiSearchSelect searchable={true} showTags={true} multiSelect={true} width="500px" onSelect={this.handleChange} options={this.state.values}/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js